import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import SEO from '../components/SEO';

const PrivacyPage = () => {
  return (
    <main className="min-h-screen bg-white pt-20">
      <SEO
        title="Politica de Confidențialitate"
        url="https://seltz.eu/privacy"
        description="Politica de Confidențialitate Seltz Vodka Soda. Află cum îți protejăm datele."
      />
      {/* Hero */}
      <section
        className="py-16 text-center"
        style={{ background: 'linear-gradient(145deg, #0f0f0f 0%, #0a0a0a 100%)' }}
      >
        <h1
          className="text-white font-black italic mb-3"
          style={{ fontFamily: 'Nunito, sans-serif', fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}
        >
          politica de confidențialitate
        </h1>
        <p className="text-white/70 text-sm" style={{ fontFamily: 'Nunito, sans-serif' }}>
          Ultima actualizare: Iulie 2025
        </p>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-sm text-gray-400 mb-10" style={{ fontFamily: 'Nunito, sans-serif' }}>
            <Link to="/" className="hover:text-[#0a0a0a] transition-colors">Acasă</Link>
            <ChevronRight size={14} />
            <span className="text-[#0a0a0a] font-bold">Politica de Confidențialitate</span>
          </div>

          <div className="space-y-10" style={{ fontFamily: 'Nunito, sans-serif' }}>

            <div className="bg-blue-50 rounded-2xl p-6 border border-blue-100">
              <p className="text-[#0a0a0a] text-sm leading-relaxed font-semibold">
                Seltz Spirits LLC respectă confidențialitatea utilizatorilor săi. Această politică descrie modul în care colectăm, utilizăm și protejăm informațiile dumneavoastră personale.
              </p>
            </div>

            <Section title="1. Informații pe Care le Colectăm">
              <p>Colectăm următoarele categorii de informații:</p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li><strong>Informații de identificare:</strong> Nume, prenume, adresă de email</li>
                <li><strong>Date de verificare vârstă:</strong> Data nașterii (stocată local în browser, nu pe serverele noastre)</li>
                <li><strong>Date de livrare:</strong> Adresă, oraș, cod poștal, țară (la plasarea comenzilor)</li>
                <li><strong>Date de utilizare:</strong> Adresa IP, tipul browser-ului, paginile vizitate, durata sesiunii</li>
                <li><strong>Date de newsletter:</strong> Adresa de email și preferințele de comunicare</li>
              </ul>
            </Section>

            <Section title="2. Cum Utilizăm Informațiile">
              <p>Informațiile colectate sunt utilizate pentru:</p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Procesarea și livrarea comenzilor</li>
                <li>Trimiterea de comunicări de marketing (doar dacă v-ați abonat)</li>
                <li>Îmbunătățirea experienței pe site</li>
                <li>Verificarea vârstei legale pentru consumul de alcool</li>
                <li>Respectarea obligațiilor legale</li>
                <li>Prevenirea fraudei și asigurarea securității</li>
              </ul>
            </Section>

            <Section title="3. Cookie-uri">
              <p>Utilizăm cookie-uri și tehnologii similare pentru:</p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li><strong>Cookie-uri esențiale:</strong> Necesare pentru funcționarea site-ului (verificarea vârstei, coșul de cumpărături)</li>
                <li><strong>Cookie-uri analitice:</strong> Ne ajută să înțelegem cum este utilizat site-ul</li>
                <li><strong>Cookie-uri de marketing:</strong> Folosite pentru publicitate personalizată</li>
              </ul>
              <p className="mt-3">Puteți dezactiva cookie-urile din setările browser-ului, dar aceasta poate afecta funcționalitatea site-ului.</p>
            </Section>

            <Section title="4. Partajarea Datelor">
              <p>Nu vindem, nu închiriem și nu divulgăm datele personale ale utilizatorilor către terți, cu excepția:</p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Partenerilor logistici pentru livrarea comenzilor</li>
                <li>Procesoarelor de plată pentru tranzacții financiare</li>
                <li>Autorităților competente, atunci când legea o impune</li>
                <li>Furnizorilor de servicii care procesează date în numele nostru</li>
              </ul>
            </Section>

            <Section title="5. Securitatea Datelor">
              <p>Implementăm măsuri tehnice și organizatorice adecvate pentru protejarea datelor personale împotriva accesului neautorizat, modificării, divulgării sau distrugerii. Transmiterea datelor se face prin conexiuni securizate (HTTPS).</p>
            </Section>

            <Section title="6. Drepturile Dumneavoastră">
              <p>Aveți următoarele drepturi cu privire la datele personale:</p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li><strong>Dreptul de acces:</strong> Puteți solicita o copie a datelor pe care le deținem despre dumneavoastră</li>
                <li><strong>Dreptul la rectificare:</strong> Puteți solicita corectarea datelor inexacte</li>
                <li><strong>Dreptul la ștergere:</strong> Puteți solicita ștergerea datelor personale</li>
                <li><strong>Dreptul la portabilitate:</strong> Puteți solicita exportul datelor într-un format structurat</li>
                <li><strong>Dreptul de opoziție:</strong> Vă puteți opune prelucrării datelor în scopuri de marketing</li>
              </ul>
              <p className="mt-3">Pentru exercitarea acestor drepturi, contactați-ne prin pagina de <Link to="/contact" className="text-[#0a0a0a] font-bold underline">contact</Link>.</p>
            </Section>

            <Section title="7. Retenția Datelor">
              <p>Păstrăm datele personale doar atât cât este necesar pentru scopurile descrise în această politică sau conform cerințelor legale aplicabile. Datele de newsletter sunt păstrate până la dezabonare.</p>
            </Section>

            <Section title="8. Modificări ale Politicii">
              <p>Ne rezervăm dreptul de a modifica această politică periodic. Vă recomandăm să verificați regulat această pagină. Modificările semnificative vor fi notificate prin email (dacă sunteți abonat).</p>
            </Section>

            <Section title="9. Contact">
              <p>Pentru orice întrebări legate de protecția datelor, contactați-ne la: <Link to="/contact" className="text-[#0a0a0a] font-bold underline">pagina de contact</Link>.</p>
            </Section>
          </div>
        </div>
      </section>
    </main>
  );
};

const Section = ({ title, children }) => (
  <div className="border-b border-gray-100 pb-8">
    <h2
      className="text-[#0a0a0a] font-black italic text-xl mb-4"
      style={{ fontFamily: 'Nunito, sans-serif' }}
    >
      {title}
    </h2>
    <div className="text-gray-600 leading-relaxed text-sm space-y-3">
      {children}
    </div>
  </div>
);

export default PrivacyPage;
